// extracted by mini-css-extract-plugin
export var actionSelect = "_sn-0";